import * as types from '../mutation-types'
import api from '@/api/projects'

// initial state
const state = {
    projects: [],
    loaded: false,
}

const getters = {
    projects: state => state.projects,
    projectsLoaded: state => state.loaded,
}

const actions = {
    getProjects({ commit }) {
        commit(types.SET_PROJECTS_LOADED, false );
        api.getProjects({_embed: 1},(response) => {
            commit(types.SET_PROJECTS, response._embedded.Project );
            commit(types.SET_PROJECTS_LOADED, true );
        })
    },
    cleanInitiatives({commit}) {
        commit(types.SET_PROJECTS_LOADED, false );
        commit(types.SET_PROJECTS, {} );
    }
}

const mutations = {
    [types.SET_PROJECTS] (state, projects ) {
        state.projects = projects
    },
    [types.SET_PROJECTS_LOADED] (state, status ) {
        state.loaded = status
    },
}


export default {
    state,
    getters,
    actions,
    mutations
}


